app.run([
  '$rootScope',
  'mainConfig',
  '$filter',
  'productService',
  'trackerService',
  'cartService',
  'slFeatureService',
  function (
    $rootScope,
    mainConfig,
    $filter,
    productService,
    trackerService,
    cartService,
    slFeatureService,
  ) {
    if (!slFeatureService.hasFeature('google_analytics_4')) {
      return;
    }
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    const baseCurrencyCode = mainConfig.merchantData.base_currency_code;
    const { generalEventType } = trackerService;

    const transformItem = (item) => ({
      item_id: productService.getSku(item.product_id, item.sku, item.variation),
      item_name: $filter('translateModel')(item.product.title_translations),
      ...(item.product.brand ? { item_brand: item.product.brand } : {}),
      price: cartService.getItemPrice(item).dollars || 0,
      quantity: item.quantity,
    });

    $rootScope.$on(generalEventType.REGISTRATION, () => {
      gtag('event', 'sign_up', {});
    });
    $rootScope.$on(generalEventType.SEARCH, (e, data) => {
      gtag('event', 'search', {
        search_term: data.query,
      });
    });
    $rootScope.$on(generalEventType.PRODUCT_CLICK, (e, data) => {
      gtag('event', 'select_item', {
        items: [
          {
            item_id: data.product_sku,
            item_name: data.product_title,
            quantity: 1,
          },
        ],
      });
    });
    $rootScope.$on(generalEventType.VIEW_CONTENT, (e, data) => {
      gtag('event', 'view_item', {
        currency: baseCurrencyCode,
        value: data.value,
        items: [
          {
            item_id: productService.getSku(
              data.product._id,
              data.product.sku,
              data.variationSelected,
            ),
            item_name: $filter('translateModel')(
              data.product.title_translations,
            ),
            discount: Math.max(data.product.price?.cents - data.value || 0, 0),
            ...(data.product.brand ? { item_brand: data.product.brand } : {}),
            price: data.product.price?.cents || data.value,
            quantity: 1,
          },
        ],
      });
    });
    $rootScope.$on(generalEventType.ADD_TO_WISHLIST, (e, data) => {
      gtag('event', 'add_to_wishlist', {
        currency: baseCurrencyCode,
        value: data.value,
        items: [
          {
            item_id: data.product_id,
            quantity: 1,
          },
        ],
      });
    });
    $rootScope.$on(generalEventType.ADD_TO_CART, (e, data) => {
      gtag('event', 'add_to_cart', {
        currency: baseCurrencyCode,
        value: data.value,
        items: [
          {
            item_id: productService.getSku(
              data.product._id,
              data.product.sku,
              data.variationSelected,
            ),
            item_name: $filter('translateModel')(
              data.product.title_translations,
            ),
            discount: Math.max(data.product.price?.cents - data.value || 0, 0),
            ...(data.product.brand ? { item_brand: data.product.brand } : {}),
            price: data.product.price?.cents || data.value,
            quantity: 1,
          },
        ],
      });
    });
    $rootScope.$on(generalEventType.REMOVE_FROM_CART, (e, data) => {
      gtag('event', 'remove_from_cart', {
        currency: baseCurrencyCode,
        value: data.value,
        items: [
          {
            item_id: productService.getSku(
              data.product._id,
              data.product.sku,
              data.variationSelected,
            ),
            item_name: $filter('translateModel')(
              data.product.title_translations,
            ),
            ...(data.product.brand ? { item_brand: data.product.brand } : {}),
            price: data.product.price?.cents || data.value,
            quantity: data.product.quantity,
          },
        ],
      });
    });
    $rootScope.$on(generalEventType.START_CHECKOUT, (e, data) => {
      gtag('event', 'view_cart', {
        currency: baseCurrencyCode,
        value: data.subtotal?.dollars || 0,
        items: data.items.map((item, index) => ({
          item_id: productService.getSku(
            item.product._id,
            item.product.sku,
            item.variationSelected,
          ),
          item_name: $filter('translateModel')(item.product.title_translations),
          ...(item.product.brand ? { item_brand: item.product.brand } : {}),
          price: cartService.getItemPrice(item).dollars || 0,
          quantity: item.quantity,
          index,
        })),
      });
    });
    $rootScope.$on(generalEventType.INITIATE_CHECKOUT, (e, data) => {
      gtag('event', 'begin_checkout', {
        currency: baseCurrencyCode,
        value: data.subtotal?.dollars || 0,
        items: data.items.map((item, index) => ({
          ...transformItem(item),
          index,
        })),
      });
    });
    $rootScope.$on(generalEventType.ADD_SHIPPING, (e, data) => {
      gtag('event', 'add_shipping_info', {
        currency: baseCurrencyCode,
        value: data.subtotal?.dollars || 0,
        items: data.items.map((item, index) => ({
          ...transformItem(item),
          index,
        })),
      });
    });
    $rootScope.$on(generalEventType.ADD_BILLING, (e, data) => {
      gtag('event', 'add_payment_info', {
        currency: baseCurrencyCode,
        value: data.subtotal?.dollars || 0,
        items: data.items.map((item, index) => ({
          ...transformItem(item),
          index,
        })),
      });
    });
    $rootScope.$on(generalEventType.PURCHASE, (e, data) => {
      gtag('event', 'purchase', {
        currency: baseCurrencyCode,
        transaction_id: data.transactionId,
        value: data.subtotal?.dollars || 0,
        shipping: data.shipping || 0,
        items: data.items.map((item, index) => ({
          item_id: productService.getSku(
            item.item_id,
            item.object_data.sku,
            item.variation_data,
          ),
          item_name: $filter('translateModel')(
            item.object_data.title_translations,
          ),
          ...(item.object_data.brand
            ? { item_brand: item.object_data.brand }
            : {}),
          price: item.item_price.dollars || 0,
          quantity: item.quantity,
          index,
        })),
      });
    });
  },
]);
